import { render, staticRenderFns } from "./NotifyRotateTablet.vue?vue&type=template&id=2e228e90&scoped=true&"
import script from "./NotifyRotateTablet.vue?vue&type=script&lang=js&"
export * from "./NotifyRotateTablet.vue?vue&type=script&lang=js&"
import style0 from "./NotifyRotateTablet.vue?vue&type=style&index=0&id=2e228e90&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e228e90",
  null
  
)

export default component.exports